module.exports = __webpack_public_path__ + "static/media/info.a13a7fc4.svg";